import { toast } from "react-toastify";
import { BASE_URL } from "./config";

export const getUserData = () => {
  let userDetails = localStorage.getItem("user");
  return JSON.parse(userDetails);
};
getUserData();

export const logout = () => {
  localStorage.clear();
  window.location.replace("login");
};

export const login = async (userData) => {
  try {
    const response = await fetch(BASE_URL + "users/login", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    });
    const result = await response.json();
    return { result };
  } catch (error) {
    return { status: false, message: "Something went wrong" };
  }
};

export const getUser = async (searchQuery, page, limit) => {
  const token = localStorage.getItem("token");
  let url = `${BASE_URL}users?email=${searchQuery}`;
  if (page !== undefined && limit !== undefined) {
    url += `&page=${page}&limit=${limit}`;
  }
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    const result = await response.json();
    return { status: true, result };
  } catch (error) {
    return { status: false, message: "Something went wrong" };
  }
};

export const updateUser = async (user) => {
  const token = localStorage.getItem("token");
  try {
    const response = await fetch(`${BASE_URL}users/update-user/${user._id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(user),
    });
    const result = await response.json();
    return { status: true, result };
  } catch (error) {
    return { status: false, message: "Something went wrong" };
  }
};

export const deleteUser = async (user) => {
  const token = localStorage.getItem("token");
  try {
    const response = await fetch(`${BASE_URL}users/delete-user/${user._id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(user),
    });
    const result = await response.json();
    return { status: true, result };
  } catch (error) {
    return { status: false, message: "Something went wrong" };
  }
};

export const addUser = async (data) => {
  const token = localStorage.getItem("token");
  try {
    return fetch(BASE_URL + "users/add-user", {
      method: "POST",
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  } catch (error) {
    throw error.response?.data || "File upload failed";
  }
};

export const uploadFile = async (data) => {
  // console.log("data",data.fileId);
  
  const token = localStorage.getItem("token");
  try {
    const formData = new FormData();
    if (data?.file) {
      formData.append("file", data.file);
    }
    formData.append("userId", data?.userId);
    formData.append("industry", data?.industry);
    if (data?.fileId) {
      formData.append("parentId", data.fileId); // Ensure parentId is sent for reprocessing
    }
    if (data?.filename) {
      formData.append("filename", data.filename);
    }
    if (data?.filepath) {
      formData.append("filepath", data.filepath);
    }
    // console.log("formData",formData);
    

    return fetch(BASE_URL + "curated-api/curate-excel", {
      method: "POST",
      headers: {
        Authorization: token,
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
        return { result: false, message: "File upload failed" };
      });
  } catch (error) {
    throw error.response?.data || "File upload failed";
  }
};

export const fetchFile = async (data) => {
  const token = localStorage.getItem("token");
  if (!token) {
    console.error("No token found, redirecting to login...");
    window.location.href = "/login";
    return { data: [], totalPages: 1, currentPage: 1 };
  }
  try {
    const response = await fetch(
      `${BASE_URL}curated-api/fetch-all-files?page=${data.page}&limit=${data.limit}&search=${data.filters?.searchQuery || ""}&industry=${data.industry}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ filters: data.filters }),
      }
    );    
    if (response.status === 401) {
      // console.error("Unauthorized access, redirecting to login...");
      localStorage.removeItem("token"); 
      localStorage.removeItem('isLoggedIn')
      window.location.href = "/login";
      return { data: [], totalPages: 1, currentPage: 1 };
    }
    const result = await response.json();

    const fileMap = new Map();

    result.data.forEach((file) => {

      if (!file.parentId) {
        file.reprocessedFiles = [];
        fileMap.set(file._id, file);
      } else if (fileMap.has(file.parentId)) {
        fileMap.get(file.parentId).reprocessedFiles.push(file);
      }
    });
    return {
      data: Array.from(fileMap.values()),
      pagination: result.pagination,
    };
  } catch (error) {
    console.log(error);
    return { data: [], totalPages: 1, currentPage: 1 };
  }
};

export const getFdfMasterData = async (data) => {
  const token = localStorage.getItem("token");
  if (!token) {
    console.error("No token found, redirecting to login...");
    window.location.href = "/login";
    return { data: [], totalPages: 1, currentPage: 1 };
  }
  try {
    const response = await fetch(
      `${BASE_URL}master-data/fdf?page=${data.page}&limit=${data.limit}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ search: data?.searchQuery || ""}),
      }
    );    
    if (response.status === 401) {
      // console.error("Unauthorized access, redirecting to login...");
      localStorage.removeItem("token"); 
      localStorage.removeItem('isLoggedIn')
      window.location.href = "/login";
      return { data: [], totalPages: 1, currentPage: 1 };
    }
    const result = await response.json();

    return { status: true, result };
    // const fileMap = new Map();

    // result.data.forEach((file) => {

    //   if (!file.parentId) {
    //     file.reprocessedFiles = [];
    //     fileMap.set(file._id, file);
    //   } else if (fileMap.has(file.parentId)) {
    //     fileMap.get(file.parentId).reprocessedFiles.push(file);
    //   }
    // });
    // return {
    //   data: Array.from(fileMap.values()),
    //   pagination: result.pagination,
    // };
  } catch (error) {
    console.log(error);
    return { data: [], totalPages: 1, currentPage: 1 };
  }
};

export const fetchProcessData = async (file) => {
  const token = localStorage.getItem("token");
  try {
    return fetch(BASE_URL + `curated-api/file-status/${file}`, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  } catch (error) {
    throw error.response?.data || "File upload failed";
  }
};

export const downloadFile = async (name) => {
  const token = localStorage.getItem("token");
  try {
    const response = await fetch(BASE_URL + "curated-api/download-latest", {
      method: "POST",
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(name),
    });

    if (!response.ok) {
      throw new Error("Failed to download file");
    }

    const blob = await response.blob();
    const fileName = name.fileUrl.split("/").pop();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Download error:", error);
    toast.error("Failed to download the file.");
  }
};

export const downloadProccessedFile = async(name) => {
  const token = localStorage.getItem("token");
  try {
    
  } catch (err) {
    console.error("Download error:", err);
    toast.error("Failed to download the file.");
  }
}

export const manualCheck = async (data) => {
  const token = localStorage.getItem("token");
  try {
    const response = await fetch(BASE_URL + "curate-product/curate-single-data", {
      method: "POST",
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Manual check error:", error);
    return { error: "File upload failed" };
  }
};

export const getAllProductName = async (page, limit) => {
  const token = localStorage.getItem("token");
  let url = `${BASE_URL}curate-product/fetch-all?page=${page}&limit=${limit}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    const result = await response.json();
    return { status: true, result };
  } catch (error) {
    return { status: false, message: "Something went wrong" };
  }
};

export const getAllConfigureProducts = async (page, limit , filters) => {  
  // console.log("filter",filters);
  const token = localStorage.getItem("token");
  let url = `${BASE_URL}configure-product/all-configure-products?page=${page}&limit=${limit}&search=${filters?.searchQuery || ""}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    const result = await response.json();
    return { status: true, result  };
  } catch (error) {
    return { status: false, message: "Something went wrong" };
  }
};
export const getAllVerifyProducts = async (page, limit , filters) => {  
  // console.log("filter",filters);
  const token = localStorage.getItem("token");
  let url = `${BASE_URL}verify-product/all-verify-products?page=${page}&limit=${limit}&search=${filters?.searchQuery || ""}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    const result = await response.json();
    return { status: true, result  };
  } catch (error) {
    return { status: false, message: "Something went wrong" };
  }
};
export const addRecord = async (data) => {
  const token = localStorage.getItem("token");
  try {
    return fetch(BASE_URL + "configure-product/add-Record", {
      method: "POST",
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  } catch (error) {
    throw error.response?.data || "Record failed";
  }
};


export const updateRecord = async (data) => {
  console.log("data",data);
  
  const token = localStorage.getItem("token");
  try {
    const response = await fetch(`${BASE_URL}configure-product/update-record/${data._id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    return { status: true, result };
  } catch (error) {
    return { status: false, message: "Something went wrong" };
  }
};

export const getPendingProduct = async (query) => {
  const token = localStorage.getItem("token");
  try {
    console.log("query::>",query)
    const response = await fetch(`${BASE_URL}verify-product/${query.fileId}/${query.id}?_file=${query._file}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    const data = await response.json();
    return { status: true, data };
  } catch (error) {
    return { status: false, message: "Something went wrong" };
  }
}

export const validateProduct = async (query) => {
  const token = localStorage.getItem("token");
  try {
    console.log("query::>",query)
    const response = await fetch(`${BASE_URL}verify-product/validate/${query.fileId}/${query.id}?_file=${query._file}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    const data = await response.json();
    return { status: true, data };
  } catch (error) {
    return { status: false, message: "Something went wrong" };
  }
}

export const updateProduct = async (query,formData) => {
  const token = localStorage.getItem("token");
  try {
    console.log("query::>",query)
    const response = await fetch(`${BASE_URL}verify-product/validate/${query.fileId}/${query.id}?_file=${query._file}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(formData)
    });
    const data = await response.json();
    return { status: true, data };
  } catch (error) {
    return { status: false, message: "Something went wrong" };
  }
}